export const formatError = (error: any) => {
  if (error?.response?.data?.error) {
    return error?.response?.data?.error;
  }

  return error?.response?.data?.message
    ? error.response?.data?.message
    : JSON.stringify(error);
};

function textoDeErrosValidacao(errors: unknown): string | null {
  if (!errors || typeof errors != "object") {
    return null;
  }
  const obj = errors as Record<string, unknown>;
  const partes: string[] = [];
  for (const key of Object.keys(obj)) {
    const v = obj[key];
    if (Array.isArray(v) && v.length > 0) {
      partes.push(String(v[0]));
    } else if (v != null) {
      partes.push(String(v));
    }
  }
  return partes.length > 0 ? partes.join(" ") : null;
}

function mensagemDeCorpoJson(parsed: Record<string, unknown>): string | null {
  if (parsed.error != null) {
    return String(parsed.error);
  }
  if (parsed.message != null) {
    return String(parsed.message);
  }
  const errosVal = textoDeErrosValidacao(parsed.errors);
  if (errosVal) {
    return errosVal;
  }
  return null;
}

export async function formatAxiosErrorMessage(error: any): Promise<string> {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text) as Record<string, unknown>;
      const msg = mensagemDeCorpoJson(parsed);
      if (msg) {
        return msg;
      }
      if (text.length > 0 && text.length < 800 && !/^\s*[\[{]\s*[\]}]\s*$/.test(text)) {
        return text;
      }
    } catch {
      return "Não foi possível ler a mensagem de erro. Tente de novo.";
    }
    return formatError({
      ...error,
      response: error.response ? { ...error.response, data: undefined } : error.response,
    });
  }
  return formatError(error);
}
